// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Download_wrapper__Ngkkp","content":"Download_content__3F5wP","title":"Download_title__bKJQX","icon":"Download_icon__3QTD9","progress":"Download_progress__1Lz0W"};